import { AbilityBuilder } from '@casl/ability';
import commonActions from '../abilityActions';
import { isInRole } from '../abilityHelpers';
import userRoles from '../userRoles';
import sectionsAndPages from '../../sectionsAndPages';

const { reporting } = sectionsAndPages;

export default function getRules(user) {
  const { rules, can } = AbilityBuilder.extract();
  const { navigateTo } = commonActions;
  const { projectManager, teamLead, admin, accountant } = userRoles;

  if (isInRole(user, [projectManager, teamLead, admin, accountant])) {
    can(navigateTo, reporting);
  }

  return rules;
}
